import React from 'react';

const CartProductTitle = ({ isStorefrontMode, lineItem }) => {
  const productUrl = isStorefrontMode ? `/products/${lineItem.merchandise.product.handle}` : lineItem.url;

  const productTitle = isStorefrontMode ? lineItem.merchandise?.product.title : lineItem.product_title;

  return (
    <>
      <a
        className="body-3-bold block truncate"
        href={productUrl}
      >
        {productTitle}
      </a>
    </>
  );
};

export default CartProductTitle;
